/*
 * Widget WhatsApp flottante — logica
 * ------------------------------------------------------------
 * Custom element <whatsapp-widget>:
 *  - apre/chiude la card chat (attributo [open]);
 *  - chiude con Esc o cliccando fuori;
 *  - si nasconde quando il footer entra in viewport o quando è
 *    visibile la barra sticky "aggiungi al carrello" (stessa logica
 *    del widget IA in basso a destra);
 *  - aggiorna l'orario nella bolla del messaggio.
 */
(function () {
  if (customElements.get('whatsapp-widget')) return;

  class WhatsAppWidget extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-wa-toggle]');
      this.closeBtn = this.querySelector('[data-wa-close]');
      this.panel = this.querySelector('[data-wa-panel]');
      this.timeEl = this.querySelector('[data-wa-time]');

      if (!this.toggle || !this.panel) return;

      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.toggle.addEventListener('click', this.onToggle);
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);

      this.hiddenByFooter = false;
      this.hiddenBySticky = false;

      this.setTime();
      this.watchFooter();
      this.watchStickyCart();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
      if (this.footerObserver) this.footerObserver.disconnect();
      if (this.stickyObserver) this.stickyObserver.disconnect();
    }

    get isOpen() {
      return this.hasAttribute('open');
    }

    onToggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.setAttribute('open', '');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.panel.removeAttribute('aria-hidden');
      // Porta il focus sulla CTA per la navigazione da tastiera
      const cta = this.panel.querySelector('[data-wa-cta]');
      if (cta) cta.focus({ preventScroll: true });
    }

    close(restoreFocus) {
      if (!this.isOpen) return;
      this.removeAttribute('open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('aria-hidden', 'true');
      if (restoreFocus) this.toggle.focus({ preventScroll: true });
    }

    // Applica lo stato nascosto combinando le due condizioni
    syncHidden() {
      const hidden = this.hiddenByFooter || this.hiddenBySticky;
      this.classList.toggle('wa-hidden', hidden);
      if (hidden) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) this.close(true);
    }

    onDocumentClick(event) {
      if (this.isOpen && !this.contains(event.target)) this.close();
    }

    // Orario corrente nella bolla, formato locale (es. 14:32)
    setTime() {
      if (!this.timeEl) return;
      try {
        this.timeEl.textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      } catch (e) {
        /* ignora browser senza supporto */
      }
    }

    // Nasconde il widget quando il footer è visibile
    watchFooter() {
      const footer = document.getElementById('footer');
      if (!footer || !('IntersectionObserver' in window)) return;
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          this.hiddenByFooter = entries.some((entry) => entry.isIntersecting);
          this.syncHidden();
        },
        { rootMargin: '0px 0px -60px 0px', threshold: 0 }
      );
      this.footerObserver.observe(footer);
    }

    // Nasconde il widget quando la barra sticky "aggiungi al carrello" è visibile
    watchStickyCart() {
      const sticky = document.querySelector('product-add-to-cart-sticky');
      if (!sticky) return;
      const sync = () => {
        this.hiddenBySticky = sticky.classList.contains('sticky--visible');
        this.syncHidden();
      };
      this.stickyObserver = new MutationObserver(sync);
      this.stickyObserver.observe(sticky, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
  }

  customElements.define('whatsapp-widget', WhatsAppWidget);
})();
